export type MarkerConfig = {
  id: string;
  category: 'numbering' | 'check' | 'list-marker';
  path: string | null;
  textColor?: string | null;
  backgroundColor?: string | null;
  backgroundGradient?: string | null;
};

export enum NumberingMarker {
  One = 'numbering-1',
  Two = 'numbering-2',
  Three = 'numbering-3',
  Four = 'numbering-4',
  Five = 'numbering-5',
  Six = 'numbering-6',
  Seven = 'numbering-7',
  Eight = 'numbering-8',
  Nine = 'numbering-9',
  TwentyOne = 'numbering-21',
  TwentyTwo = 'numbering-22',
}

export enum CheckMarker {
  One = 'check-1',
  Two = 'check-2',
  Three = 'check-3',
  Four = 'check-4',
  Five = 'check-5',
  Six = 'check-6',
  TwentyOne = 'check-21',
  TwentyTwo = 'check-22',
  TwentyThree = 'check-23',
  TwentyFour = 'check-24',
  TwentyFive = 'check-25',
  TwentySix = 'check-26',
  TwentySeven = 'check-27',
  TwentyEight = 'check-28',
  TwentyNine = 'check-29',
  Thirty = 'check-30',
}

export enum ListMarker {
  One = 'list-marker-1',
  Two = 'list-marker-2',
  Three = 'list-marker-3',
  Four = 'list-marker-4',
  TwentyOne = 'list-marker-21',
  TwentyTwo = 'list-marker-22',
}

export const MARKERS: readonly MarkerConfig[] = [
  { id: NumberingMarker.One,   category: 'numbering', path: null, textColor: '#ffffff', backgroundColor: null,        backgroundGradient: 'linear-gradient(90deg, #0aafe9 0%, #1adc92 100%)' },
  { id: NumberingMarker.Two,   category: 'numbering', path: null, textColor: '#ffffff', backgroundColor: '#b95ead',   backgroundGradient: null },
  { id: NumberingMarker.Three, category: 'numbering', path: null, textColor: '#ffffff', backgroundColor: '#b95ead',   backgroundGradient: null },
  { id: NumberingMarker.Four,  category: 'numbering', path: null, textColor: '#ffffff', backgroundColor: '#02af9a',   backgroundGradient: null },
  { id: NumberingMarker.Five,  category: 'numbering', path: null, textColor: '#ffffff', backgroundColor: '#02af9a',   backgroundGradient: null },
  { id: NumberingMarker.Six,   category: 'numbering', path: null, textColor: '#14B8A6', backgroundColor: '#ffffff',   backgroundGradient: null },
  { id: NumberingMarker.Seven, category: 'numbering', path: null, textColor: '#14B8A6', backgroundColor: null,        backgroundGradient: null },
  { id: NumberingMarker.Eight,     category: 'numbering', path: null,                  textColor: '#bee1b9', backgroundColor: null, backgroundGradient: null },
  { id: NumberingMarker.TwentyOne, category: 'numbering', path: '/markers/fon21.svg', textColor: '#ffffff', backgroundColor: null, backgroundGradient: null },
  { id: NumberingMarker.TwentyTwo, category: 'numbering', path: '/markers/fon22.svg', textColor: '#ffffff', backgroundColor: null, backgroundGradient: null },

  // { id: CheckMarker.One,   category: 'check', path: '/markers/check-1.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: CheckMarker.Two,   category: 'check', path: '/markers/check-2.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: CheckMarker.Three, category: 'check', path: '/markers/check-3.svg', textColor: '#ffffff', backgroundColor: null, backgroundGradient: 'linear-gradient(0deg, #02af9a 0%, #02af9a 100%)' },
  { id: CheckMarker.Four, category: 'check',  path: '/markers/check-3.svg', textColor: '#ffffff', backgroundColor: null, backgroundGradient: 'linear-gradient(90deg, #0aafe9 0%, #1adc92 100%)' },
  { id: CheckMarker.Five,  category: 'check', path: '/markers/check-4.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: CheckMarker.Six,  category: 'check', path: '/markers/check-5.svg', textColor: null, backgroundColor: null, backgroundGradient: null },

  { id: ListMarker.One,   category: 'list-marker', path: '/markers/marker-1.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: ListMarker.Two,   category: 'list-marker', path: '/markers/marker-2.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: ListMarker.Three, category: 'list-marker', path: '/markers/marker-3.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: ListMarker.Four,  category: 'list-marker', path: '/markers/marker-4.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: ListMarker.TwentyOne, category: 'list-marker', path: '/markers/fon21.svg', textColor: null, backgroundColor: null, backgroundGradient: null },
  { id: ListMarker.TwentyTwo, category: 'list-marker', path: '/markers/fon22.svg', textColor: null, backgroundColor: null, backgroundGradient: null },

  // Нові чек-маркери (21-30): backgroundGradient вмикає CSS-mask → колір стає змінюваним
  { id: CheckMarker.TwentyOne,   category: 'check', path: '/markers/check21.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentyTwo,   category: 'check', path: '/markers/check22.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentyThree, category: 'check', path: '/markers/check23.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentyFour,  category: 'check', path: '/markers/check24.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentyFive,  category: 'check', path: '/markers/check25.svg', textColor: '#ffffff', backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentySix,   category: 'check', path: '/markers/check26.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentySeven, category: 'check', path: '/markers/check27.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentyEight, category: 'check', path: '/markers/check28.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.TwentyNine,  category: 'check', path: '/markers/check29.svg', textColor: '#ffffff', backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #97e0ff 0%, #1075ff 100%)' },
  { id: CheckMarker.Thirty,      category: 'check', path: '/markers/check30.svg', textColor: null,      backgroundColor: null, backgroundGradient: 'linear-gradient(180deg, #ffb3b3 0%, #f9595f 100%)' },
];

export type MarkersConfig = typeof MARKERS;


